import { sweepMobileSegments, sweepSegments, type SweepReading } from '../lib/sweep'

/**
 * The permanent status bar (appendix A §A3). Its reference is a vim statusline,
 * not a product notification strip: it is always present, it is never dismissed,
 * and every number on it is checkable against the index.
 *
 * It states how fresh the index is, not how the crawler feels. Pipeline health
 * is a real thing to publish and belongs on `/status`, which this bar links to.
 */
export function SweepBar({ reading, now }: { reading: SweepReading; now: number }) {
  const segments = sweepSegments(reading, now)
  const mobile = sweepMobileSegments(reading, now)

  return (
    <div className="sweep-bar" role="status" aria-label="Index freshness">
      <div className="container">
        <span className="sweep-live" data-state="ok" aria-hidden="true" />
        <span className="sweep-full">
          {segments.map((segment, index) => (
            <span key={segment}>
              {index ? <span className="sweep-sep"> │ </span> : null}
              {segment}
            </span>
          ))}
        </span>
        <span className="sweep-mobile">
          {mobile.map((segment, index) => (
            <span key={segment}>
              {index ? <span className="sweep-sep"> · </span> : null}
              {segment}
            </span>
          ))}
        </span>
        <a className="sweep-host sweep-full" href="/status">index status ↗</a>
      </div>
    </div>
  )
}
